import React, { useState, useEffect } from 'react';
import { Images } from 'utils';
import { useFormBuilder, formPageEnums } from '../formContext';
import { SelectTypeAutocomplete } from '../../../../components';

export const HeaderFooterProperties = () => {
    const { formList, setFormList, activeFormPage, setActiveFormPage } = useFormBuilder();

    const pageKey = activeFormPage === formPageEnums.HEADER ? 'header' : 'footer';
    const pageData = formList?.[pageKey] || { content: '', properties: {} };
    const properties = pageData?.properties || {};
    const pageLabel = activeFormPage === formPageEnums.HEADER ? 'Header' : 'Footer';
    const borderLabel = activeFormPage === formPageEnums.HEADER ? 'Show Bottom Border' : 'Show Top Border';

    const [localBorderColor, setLocalBorderColor] = useState(properties.borderColor || '#475467');
    const [localBgColor, setLocalBgColor] = useState(properties.backgroundColor || '#FFFFFF');

    useEffect(() => {
        setLocalBorderColor(properties.borderColor || '#475467');
        setLocalBgColor(properties.backgroundColor || '#FFFFFF');
    }, [pageKey]);

    const handleUpdate = (field, value) => {
        setFormList({
            ...formList,
            [pageKey]: {
                ...pageData,
                properties: {
                    ...properties,
                    [field]: value,
                },
            },
        });
    };

    return (
        <div className="properties-wrapper">
            <div className="properties-header">
                <h3>Properties</h3>
                <button className="reset-btn-by-default" onClick={() => setActiveFormPage(null)}>
                    <img src={Images.closeSingleVector} alt="close" style={{ width: 18, height: 18 }} />
                </button>
            </div>

            {/* STYLE Section */}
            <div className="properties-section">
                <div className="section-header">
                    <img src={Images.layoutIcon} alt="style" />
                    <span>STYLE</span>
                </div>

                <div className="behavior-row">
                    <div className="behavior-info">
                        <span className="behavior-title">{borderLabel}</span>
                    </div>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={properties.showBorder !== false}
                            onChange={(e) => handleUpdate('showBorder', e.target.checked)}
                        />
                        <span className="slider"></span>
                    </label>
                </div>

                <div className="hf-props-field">
                    <label className="hf-props-label">Border Color</label>
                    <div className="hf-color-input-row">
                        <input
                            type="color"
                            value={localBorderColor}
                            onChange={(e) => setLocalBorderColor(e.target.value)}
                            onBlur={(e) => handleUpdate('borderColor', e.target.value)}
                            className="hf-color-picker"
                        />
                        <input
                            type="text"
                            value={localBorderColor}
                            onChange={(e) => {
                                setLocalBorderColor(e.target.value);
                                handleUpdate('borderColor', e.target.value);
                            }}
                            className="hf-color-text"
                        />
                    </div>
                </div>

                <div className="hf-props-field">
                    <label className="hf-props-label">Border Width (px)</label>
                    <div className="hf-range-row">
                        <input
                            type="range"
                            min={0}
                            max={8}
                            value={properties.borderWidth ?? 1}
                            onChange={(e) => handleUpdate('borderWidth', Number(e.target.value))}
                            className="hf-range-input"
                        />
                        <span className="hf-range-value">{properties.borderWidth ?? 1}</span>
                    </div>
                </div>

                <div className="hf-props-field">
                    <label className="hf-props-label">Background Color</label>
                    <div className="hf-color-input-row">
                        <input
                            type="color"
                            value={localBgColor}
                            onChange={(e) => setLocalBgColor(e.target.value)}
                            onBlur={(e) => handleUpdate('backgroundColor', e.target.value)}
                            className="hf-color-picker"
                        />
                        <input
                            type="text"
                            value={localBgColor}
                            onChange={(e) => {
                                setLocalBgColor(e.target.value);
                                handleUpdate('backgroundColor', e.target.value);
                            }}
                            className="hf-color-text"
                        />
                    </div>
                </div>
            </div>

            {/*<div className="properties-divider" />*/}

            {/* MARGINS Section */}
            {/*<div className="properties-section">*/}
            {/*    <div className="section-header">*/}
            {/*        <img src={Images.layoutIcon} alt="margins" />*/}
            {/*        <span>MARGINS</span>*/}
            {/*    </div>*/}

            {/*    <div className="hf-margins-grid">*/}
            {/*        <div className="hf-margin-field">*/}
            {/*            <label>Top</label>*/}
            {/*            <input*/}
            {/*                type="number"*/}
            {/*                value={properties.marginTop ?? 40}*/}
            {/*                onChange={(e) => handleUpdate('marginTop', Number(e.target.value))}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="hf-margin-field">*/}
            {/*            <label>Bottom</label>*/}
            {/*            <input*/}
            {/*                type="number"*/}
            {/*                value={properties.marginBottom ?? 20}*/}
            {/*                onChange={(e) => handleUpdate('marginBottom', Number(e.target.value))}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="hf-margin-field">*/}
            {/*            <label>Left</label>*/}
            {/*            <input*/}
            {/*                type="number"*/}
            {/*                value={properties.marginLeft ?? 40}*/}
            {/*                onChange={(e) => handleUpdate('marginLeft', Number(e.target.value))}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*        <div className="hf-margin-field">*/}
            {/*            <label>Right</label>*/}
            {/*            <input*/}
            {/*                type="number"*/}
            {/*                value={properties.marginRight ?? 20}*/}
            {/*                onChange={(e) => handleUpdate('marginRight', Number(e.target.value))}*/}
            {/*            />*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="properties-divider" />

            {/* PAGE NUMBERS Section */}
            <div className="properties-section">
                <div className="section-header">
                    <img src={Images.behaivorIcon} alt="page-numbers" />
                    <span>PAGE NUMBERS</span>
                </div>

                <div className="behavior-row">
                    <div className="behavior-info">
                        <span className="hf-page-props-label">Show Page Numbers</span>
                    </div>
                    <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={!!properties.showPageNumbers}
                            onChange={(e) => handleUpdate('showPageNumbers', e.target.checked)}
                        />
                        <span className="slider"></span>
                    </label>
                </div>

                {properties.showPageNumbers && (
                    <>

                        <div className="chart-option-row">
                            <span className="hf-page-props-label">Page Number Format</span>
                            <SelectTypeAutocomplete
                                name={'pageNumberFormat'}
                                handleSelect={(e) => handleUpdate('pageNumberFormat', e.target.value)}
                                defaultValue={properties.pageNumberFormat || 'pageXofY'}
                                list={[
                                    { name: 'Page 1 of 1', id: 'pageXofY' },
                                    { name: 'Page 1', id: 'pageX' },
                                    { name: '1/1', id: 'xSlashY' },
                                    { name: '1', id: 'xOnly' },
                                ]}
                                renderValue={(i) => i?.name}
                                uiType={'tableFilter'}
                                noError={true}
                                disableClearable={true}
                            />
                        </div>

                        {/*{formList?.sections?.length > 0 && (*/}
                        {/*    <div className="hf-props-field">*/}
                        {/*        <label className="hf-props-label" style={{ marginBottom: 4 }}>How it appears</label>*/}
                        {/*        <div className="hf-page-preview-list">*/}
                        {/*            {formList.sections.map((section, idx) => (*/}
                        {/*                <div key={section.id || idx} className="hf-page-preview-row">*/}
                        {/*                    <span className="hf-page-preview-name">{section.name}</span>*/}
                        {/*                    <span className="hf-page-preview-page">Page {idx + 1} of {formList.sections.length}</span>*/}
                        {/*                </div>*/}
                        {/*            ))}*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        <div className="hf-props-field" style={{marginTop: 16}}>
                            <label className="hf-page-props-label">Content Position</label>
                            <div className="hf-position-selector">
                                {['Left', 'Center', 'Right'].map((pos) => (
                                    <div
                                        key={pos}
                                        className={`hf-position-option ${(properties.contentPosition || 'Left') === pos ? 'active' : ''}`}
                                        onClick={() => handleUpdate('contentPosition', pos)}
                                    >
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            {pos === 'Left' && (
                                                <>
                                                    <rect x="1" y="3" width="14" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="1" y="7" width="10" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="1" y="11" width="12" height="1.5" rx="0.75" fill="currentColor"/>
                                                </>
                                            )}
                                            {pos === 'Center' && (
                                                <>
                                                    <rect x="1" y="3" width="14" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="3" y="7" width="10" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="2" y="11" width="12" height="1.5" rx="0.75" fill="currentColor"/>
                                                </>
                                            )}
                                            {pos === 'Right' && (
                                                <>
                                                    <rect x="1" y="3" width="14" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="5" y="7" width="10" height="1.5" rx="0.75" fill="currentColor"/>
                                                    <rect x="3" y="11" width="12" height="1.5" rx="0.75" fill="currentColor"/>
                                                </>
                                            )}
                                        </svg>
                                        <span>{pos}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};
